import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import Article from "../pages/article/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/en/:slug",
    element: <Article />,
  },
  {
    path: "/fr/:slug",
    element: <Article />,
  },
  {
    path: "/da/:slug",
    element: <Article />,
  },
  {
    path: "/de/:slug",
    element: <Article />,
  },
  {
    path: "/:slug",
    element: <Article />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;